export default "__VITE_ASSET__2412c333__"